module.exports = __webpack_public_path__ + "static/media/youtube-icon.dfe69069.svg";